import Information from "../components/Information";
import Ranking from "../components/Ranking";
import SlotCard from "../components/SlotCard";
import slots from "../data/slots.json";
import "../css/Home.css";

const Home = () => {
  return (
    <>
      <div className="header">
        <img src="images/header.jpg" alt="header" />
      </div>
      <div className="container">
        <div className="slot-comment">
          Clusterワールドにあるパチスロホール「パーラーペロ猫」では
          レバーをクリックだけで自動でリールが停止するスロットなので誰でも簡単に遊べます
          <br />
          所持コインはワールドに保存されますので次回以降も引き続き遊んでいただけます
        </div>
        <div className="slot-gate">
          <a
            href="https://cluster.mu/w/9c301b88-7c7c-4c3c-9b1b-7d2180afa8e7"
            target="_blank"
            rel="noreferrer"
          >
            <img src="images/cluster.png" alt="cluster" />
          </a>
        </div>
        <h2 className="slot-grid">
          総来場者数：6400人 いいね：341 ぺろ猫ルーム会員：89人
        </h2>

        <div className="slot-grid">
          <video
            controls="nodownload, nofullscreen, noremoteplayback"
            autoPlay="autoplay"
            loop="loop"
          >
            <source src="/videos/introduction-low.mp4" type="video/mp4" />
          </video>
        </div>
        <Information />

        <h1>出玉ランキング</h1>
        <Ranking />
        <h1>新台</h1>
        <div className="slot-grid">
          {slots.at(-1) && (
            <SlotCard key={slots.at(-1).id} slot={slots.at(-1)} />
          )}
          {slots.at(-2) && (
            <SlotCard key={slots.at(-2).id} slot={slots.at(-2)} />
          )}
        </div>
        <h1>スロット台一覧</h1>
        <div className="slot-grid">
          {slots.map((slot) => (
            <SlotCard key={slot.id} slot={slot} />
          ))}
        </div>
      </div>
    </>
  );
};

export default Home;
